import { DataLayerModel } from '../models/data-layer.model';
import {Injectable} from "@angular/core";

@Injectable({
	providedIn: "root"
})
export abstract class GtmAbstractService {
	public abstract pushToDataLayer(event: object): void;
	public abstract pushEventToDataLayer(dataLayerModel: DataLayerModel): void;
	public abstract pushMultipleEventsToDataLayer(dataLayerModels: DataLayerModel[]): void;
}